import React from 'react';
import { Box, TextV2, ButtonV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';

interface UnpublishedWebsiteBannerProps
  extends Readonly<{
    onPublish: () => void;
    isPublishing: boolean;
  }> {}

const UnpublishedWebsiteBanner: React.FC<UnpublishedWebsiteBannerProps> = ({ onPublish, isPublishing }) => {
  const { tq } = useTranslation('publishReminder');
  const isMobile = useIsMobileScreen();

  return (
    <Box
      display="flex"
      backgroundColor="newUIBrandPrimary"
      width="100%"
      zIndex={3001}
      position="fixed"
      top={0}
      alignItems="center"
      justifyContent="center"
      paddingX={5}
      paddingY={[4, null, 5]}
      gap={[4, null, 5]}
    >
      <TextV2
        fontSize={['0.875rem', null, '1.25rem']}
        color="white"
        fontFamily="Inter UI"
        fontWeight={600}
        letterSpacing="-0.02em"
      >
        {isMobile
          ? tq`Your website is hidden from guests for now. Publish before sharing.`
          : tq`Your website is hidden from guests for now. Publish it when you’re ready to share.`}
      </TextV2>
      <ButtonV2
        flexShrink={0}
        size={isMobile ? 'sm' : 'lg'}
        variant="outline"
        intent="newPrimary"
        onClick={onPublish}
        color="white"
        borderColor="white"
        shape="rounded"
        fontFamily="Inter UI"
        fontWeight={600}
        _hover={{ backgroundColor: 'white', color: 'newUIBrandPrimary', borderColor: 'white' }}
        _active={{ backgroundColor: 'white', color: 'newUIBrandPrimary', borderColor: 'white' }}
        loading={isPublishing}
      >
        {tq`Publish Website`}
      </ButtonV2>
    </Box>
  );
};

UnpublishedWebsiteBanner.displayName = 'UnpublishedWebsiteBanner';

export { UnpublishedWebsiteBanner };
